import { getCoreRowModel, useReactTable, flexRender } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';

import { CSSProperties } from 'react';

interface ReactTableProps<T extends object> {
    data: T[];
    columns: ColumnDef<T>[];
    getRowStyle?: (row: T) => CSSProperties;
    // Optional: shown in a single row under the header when there is no data
    emptyMessage?: string;
}

export const Table = <T extends object>({ data, columns, getRowStyle, emptyMessage }: ReactTableProps<T>) => {
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (

        <table className="table">
            <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th key={header.id}
                                className={header.column.id === 'actions' ? 'actionButon' : ''
                                }>
                                {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr key={row.id} style={getRowStyle ? getRowStyle(row.original) : {}}>
                        {row.getVisibleCells().map((cell) => (
                            <td style={getRowStyle ? getRowStyle(row.original) : {}} className={`text-nowrap ${cell.column.id === 'actions' ? 'actionButton' : ''}`} key={cell.id}>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                        ))}
                    </tr>
                ))}
                {emptyMessage && table.getRowModel().rows.length === 0 && (
                    <tr>
                        <td colSpan={table.getAllLeafColumns().length} className="text-center py-4">
                            {emptyMessage}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};